import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["big", "children", "error", "focused", "hasValue", "id", "labelFeedbackStateIconStyle", "textStyle", "viewStyle", "warning"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import FeedbackStateIconError from '@bubble-ui/icon-feedback-state-error';
import FeedbackStateIconErrorWrapper from '@bubble-ui/icon-feedback-state-error-wrapper';
import FeedbackStateIconWarning from '@bubble-ui/icon-feedback-state-warning';
import FeedbackStateIconWarningWrapper from '@bubble-ui/icon-feedback-state-warning-wrapper';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useAnimationControl } from '@bubble-ui/provider-animation-control';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { calculateLabelMotion } from './calculateLabelMotion';
var getDefaultStyleSheet = _ref => {
  var {
    big,
    focused,
    hasValue
  } = _ref;
  return {
    motionStyle: calculateLabelMotion({
      big,
      focused,
      hasValue
    })
  };
};
var Label = _ref2 => {
  var {
      big,
      children,
      error,
      focused,
      hasValue,
      id,
      labelFeedbackStateIconStyle,
      textStyle,
      viewStyle,
      warning
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  usePropDeprecationWarning({
    componentName: 'AtomLabel',
    propName: 'big',
    shouldWarn: big !== undefined,
    removalDate: 'v6.0.0'
  });
  var {
    disableAnimations
  } = useAnimationControl();
  var {
    motionStyle: {
      marginTop,
      fontSize
    }
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(Label, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    big,
    children,
    disableAnimations,
    error,
    focused,
    hasValue,
    id,
    labelFeedbackStateIconStyle,
    textStyle,
    viewStyle,
    warning
  }));
  return /*#__PURE__*/React.createElement(View, _extends({
    id: id,
    style: _objectSpread(_objectSpread({}, viewStyle(marginTop)), {}, {
      transition: disableAnimations ? undefined : 'margin-top .5s'
    })
  }, props), error && /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconErrorWrapper, {
    colorToken: "colors/backgrounds/error-inline"
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/React.createElement(FeedbackStateIconError, {
    colorToken: "colors/text/error"
  }))), warning && /*#__PURE__*/React.createElement(View, {
    style: labelFeedbackStateIconStyle
  }, /*#__PURE__*/React.createElement(FeedbackStateIconWarningWrapper, {
    colorToken: "colors/backgrounds/warning-inline"
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    }
  }, /*#__PURE__*/React.createElement(FeedbackStateIconWarning, {
    colorToken: "colors/text/warning"
  }))), /*#__PURE__*/React.createElement(Text, {
    style: _objectSpread(_objectSpread({}, textStyle(fontSize)), {}, {
      transition: disableAnimations ? undefined : 'font-size .5s'
    }),
    numberOfLines: 1
  }, children));
};
Label.displayName = 'AtomLabel';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default withProvisionalOverrideFromContext(Label);
//# sourceMappingURL=index.js.map